<template>
  <div>
    <div v-if="isRepruAufgabe">
      <VorgangVerlinkungRepru
        :vorgangData="vorgangData"
        :openAufgabenId="openAufgabenId"
        :reiseTermine="reiseTermine"
      />
    </div>
    <div v-else-if="isFomAufgabe">
      <VorgangVerlinkungenFom
        :vorgangData="vorgangData"
        :openAufgabenId="openAufgabenId"
        :aufgabenKategorie="aufgabenKategorie"
      />
    </div>
    <div v-else>
      <VorgangVerlinkungenBasic
        :vorgangData="vorgangData"
        :openAufgabenId="openAufgabenId"
        :gueltigeKonfiguration="gueltigeKonfiguration"
      />
    </div>
  </div>
</template>
<script>
import VorgangVerlinkungenBasic from '@/components/aufgaben/verlinkungen/vorgang-verlinkungen-basic.vue';
import VorgangVerlinkungenFom from '@/components/aufgaben/verlinkungen/vorgang-verlinkungen-fom.vue';
import VorgangVerlinkungRepru from '@/components/aufgaben/verlinkungen/vorgang-verlinkung-repru.vue';
import { FOM_KATEGORIEN } from '@/core/common/helpers/aufgaben-kategorien.js';

export default {
  components: {
    VorgangVerlinkungenBasic,
    VorgangVerlinkungenFom,
    VorgangVerlinkungRepru,
  },
  props: {
    vorgangData: { type: Array, required: true },
    openAufgabenId: { type: Number, default: null },
    aufgabenKategorie: { type: String },
    isRepruAufgabe: { type: Boolean, default: false },
    gueltigeKonfiguration: { type: Object },
    reiseTermine: { type: Array, default: () => [] },
  },
  computed: {
    isFomAufgabe() {
      return FOM_KATEGORIEN.includes(this.aufgabenKategorie);
    },
  },
};
</script>
